<section
  [class.terms-and-conditions--no-padding]="noPadding()"
  [class.terms-and-conditions__transparent]="transparent()"
  class="terms-and-conditions"
>
  @if (toggleIcon()) {
    <div class="terms-and-conditions-icon">
      <app-icon [icon]="'memo-circle-check'" [size]="'sm'" />
    </div>
  }

  <div class="terms-and-conditions-text">
    See the full inclusions and exclusions in the
    <app-link
      [navigationLink]="{
        label: 'Appliance Care Terms & Conditions',
        href: termsUrl(),
      }"
      [newWindow]="true"
      class="link--regular"
    />. Also check the policy summary in the
    <app-link
      [navigationLink]="{
        label: 'Insurance Product Information Document',
        href: ipidUrl(),
      }"
      [newWindow]="true"
      class="link--regular"
    />.
  </div>
</section>
